
export function sum(fields) {
  return fields.every(field => field != null) ? fields.reduce((previousValue, currentValue) => Number(previousValue) + Number(currentValue)) : null;
}

export function divide(field1, field2, times) {
  if (field1 != null && (field2 != null && Number(field2) !== 0)) {
    return (field1 / field2 * times).toFixed(2);
  } else {
    return null;
  }
}



